<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Cancel Sale Payments</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/cancel-payments">
                    <v-icon left>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <div>
                    <v-row dense>
                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete name="salepaymentReportAccount" dense outlined v-model="record.PaymentMode"
                                :items="accounts" label="Payment Mode" item-text="Name"
                                item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete name="salesPaymentReportCustomer" dense outlined v-model="record.CustomerId"
                                :items="customers" label="Customer" item-text="Name" item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="12" class="mb-3">
                            <v-btn class="float-right" color="primary" :loading="loader" @click="getReport">
                                <v-icon left>mdi-list-box-outline</v-icon> Query Payments
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row dense class="subtitle-2 text--primary">
                        <v-col cols="12">
                            <span class="totals">Total Payments: {{ TotalAmount | currency }}</span>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field label="Search" v-model="search" outlined dense></v-text-field>
                            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="reportData"
                                :search="search">
                                <template v-slot:item.Amount="{ item }">
                                    <span>{{ item.Amount | currency }}</span>
                                </template>

                                <template v-slot:item.date="{ item }">
                                    <span style="display: inline-block; min-width: 80px; width: 80px">
                                        {{
                                            item.date | date
                                        }}
                                    </span>
                                </template>

                                <!-- action template -->
                                <template v-slot:item.action="{ item }">
                                    <v-btn @click="openDialog(item)" color="accent" text>
                                        <v-icon left>mdi-close</v-icon> Cancel Payment
                                    </v-btn>
                                </template>
                                <!-- end -->
                            </v-data-table>
                            <!-- snackbar -->
                            <snackbar ref="snackbar"></snackbar>
                        </v-col>
                    </v-row>


                    <!-- Edit payment mode dialog -->
                    <v-dialog v-model="editDialog" max-width="750px">
                        <v-card>
                            <v-toolbar dense color="secondary" flat>
                                <v-toolbar-title>Cancel Sale Editing</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="editDialog = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row v-if="editItem" class="subtitle-2 text--primary">
                                        <v-col cols="12" xs="12" md="12">
                                            <span>{{ editItem.customer && editItem.customer.Name }}</span>
                                        </v-col>

                                        <v-col cols="12" xs="12" md="6">
                                            <span>Amount: {{ editItem.Amount }}</span>
                                        </v-col>

                                        <v-col cols="12" xs="12" md="6">
                                            <span>Account: {{ editItem.Account && editItem.Account.Name }}</span>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-btn color="accent" @click="cancelPayment" :loading="loader">
                                                <v-icon left>mdi-close</v-icon> Cancel Payment
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <!-- end of edit modal-->
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            record: {},
            pageItems: 2000,
            updatedAccount: null,
            loader: false,
            editItem: {},
            editDialog: false,
            PaymentMode: null,
            accounts: [],
            customers: [],
            search: null,
            menu1: false,
            menu2: false,
            reportData: [],
            TotalAmount: 0,
            returnPayments: [],
            TotalReturns: null,
            headers: [
                { text: "Customer", value: "customer.Name" },
                { text: "Amount", value: "Amount" },
                { text: "Payment Mode", value: "Account.Name" },
                { text: "Date", value: "date" },
                { text: "Action", value: "action" },
            ],
            fields: {
                Customer: "ocrd.Name",
                Amount: "SumApplied",
                PaymentMode: "oact.Name",
                Remarks: "PaymentRemarks",
                Date: "DocDate"
            },
            returnHeaders: [
                { text: "Customer", value: "ocrd" },
                { text: "Amount", value: "SumApplied" },
                { text: "Payment Mode", value: "oact" },
                { text: "Date", value: "DocDate" }
            ]
        };
    },
    computed: {
        storeName() {
            return localStorage.getItem("storeName");
        },
        activeStore() {
            return localStorage.getItem("store_id");
        },
        role() {
            return localStorage.getItem("userRole");
        },
        totalPayments() {
            let total = 0;
            if (this.TotalAmount) {
                total = this.TotalAmount.toLocaleString();
            }
            return total;
        }
    },
    methods: {
        openDialog(item) {
            this.editItem = item;
            this.editDialog = true;
        },
        setStartDate(date) {
            this.record.StartDate = date;
        },
        setEndDate(date) {
            this.record.EndDate = date;
        },
        cancelPayment() {
            const self = this;
            const url = `/cancel-sale-payment/${self.editItem.id}`;
            this.loader = true;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.editDialog = false;
                        this.$refs.snackbar.show("Payment cancelled successfully", "green");
                        self.getReport();
                        self.loader = false;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                         self.loader = false;
                    }
                })
                .catch(err => {
                     self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getAccounts() {
            const self = this;
            this.$store
                .dispatch("get", `/bank-accounts`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.accounts = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getReport() {
            const recordData = this.record;
            const storeId = this.activeStore;

            const data = {
                store_id: storeId,
                AccountId: recordData.PaymentMode,
                SoldBy: null,
                CustomerId: recordData.CustomerId,
                StartDate: recordData.StartDate,
                EndDate: recordData.EndDate
            };
            const url = "/debt-payments-report";
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.reportData = res.ResponseData.payments;
                        self.TotalAmount = res.ResponseData.TotalAmountPaid;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });

        },
        printDoc() {
            if (this.record.StartDate == null || this.record.EndDate == null) {
                this.$refs.snackbar.show("Please select both dates", "red");
            } else {
                this.print();
            }
        },
        print() { },
        getCustomers() {
            const self = this;
            this.$store
                .dispatch("get", `/customers`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.customers = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {
        this.getAccounts();
        this.getCustomers();
    }
};
</script>

<style lang="scss" scoped></style>